'use client'
import { serviceMapping, typeMapping } from "@/domains/agenceArticle/agenceArticle.utils"
import { Input } from "@/stories/components/Form/Input/Input"
import { CustomSelect } from "@/stories/components/Form/CustomSelect/CustomSelect"
import { LocalitySearch } from "@/stories/components/Form/LocalitySearch/LocalitySearch"
import { GeoEntity } from "@/utils/geo-search"
import { MultipleValueList } from "@/stories/components/Form/List/MultipleValueList"
import { AgenceArticleService } from "@/domains/agenceArticle/agenceArticle.types"

export type ArticleFiltersState = {
  search: string,
  service: {label: string, value: AgenceArticleService}[],
  type: string,
  codeInsee: string,
  codeDepartement: string,
}

export type ArticleFiltersProps = {
  filters: ArticleFiltersState,
  locality: GeoEntity | null,
  setFilters: (filters: ArticleFiltersState) => void,
  setLocality: (locality: GeoEntity | null) => void,
}

export const ArticleFilters = ({ filters, locality, setFilters, setLocality }: ArticleFiltersProps) => {
  const handleLocality = (localities: GeoEntity[]) => {
    const entity = localities[0] ?? null
    setLocality(entity)
    if (!entity) {
      setFilters({ ...filters, codeInsee: '', codeDepartement: '' })
    } else if (entity.type === 'commune') {
      setFilters({ ...filters, codeInsee: entity.codeInsee, codeDepartement: '' })
    } else {
      setFilters({ ...filters, codeInsee: '', codeDepartement: entity.code })
    }
  }

  return (
    <>
      <Input
        label='Recherche'
        placeholder="Rechercher par titre"
        variant="secondary"
        icon="search"
        hideLabel
        hideOptionnal
        value={filters.search}
        setValue={(value) => setFilters({ ...filters, search: value })}
      />
      <LocalitySearch
        label='Commune ou département'
        hideLabel
        localityTypes={['commune', 'departement']}
        localities={locality ? [locality] : []}
        setLocalities={handleLocality}
        id='locality'
        variant='secondary'
        icon='location-dot'
      />
      <CustomSelect
        label='Catégorie'
        value={{label: typeMapping[filters.type as keyof typeof typeMapping] ?? 'Catégorie', value: filters.type}}
        setValue={(value) => setFilters({ ...filters, type: value })}
        options={[
          { label: 'Catégorie', value: '' },
          ...Object.keys(typeMapping).map(type => ({
            label: typeMapping[type as keyof typeof typeMapping],
            value: type
          }))
        ]}
      />
      <MultipleValueList
        label='Services'
        hideLabel
        placeholder="Tags"
        variant="secondary"
        tagVariant='secondary'
        values={filters.service}
        setValues={(values) => setFilters({ ...filters, service: values as ArticleFiltersState['service']})}
        list={[
          { label: 'Tout', value: '' },
          ...Object.keys(serviceMapping).map(service => ({
            label: serviceMapping[service as keyof typeof serviceMapping],
            value: service
          }))
        ]}
      />
    </>
  )
}
